import { LatestPractitionersUpdated, useLatestPractitionersUpdated } from "hooks/useLatestPractitionersUpdated";
import { FC, createContext, PropsWithChildren, useContext } from "react";

export interface GlobalCtxProps {
  latestPractitionersUpdated: LatestPractitionersUpdated
}


export const GlobalCtx = createContext<GlobalCtxProps | null>(null);

export const GlobalProvider: FC<PropsWithChildren> = ({ children }) => {
  const latestPractitionersUpdated = useLatestPractitionersUpdated();

  return (
    <GlobalCtx.Provider
      value={{
        latestPractitionersUpdated,
      }}>
      {children}
    </GlobalCtx.Provider>
  );
};

export const useGlobalContext = (): GlobalCtxProps => {
  const ctx = useContext(GlobalCtx);
  if (!ctx) {
    throw new Error("This hook should be used inside global provider");
  }
  return ctx;
}